<script setup lang="ts">
import { defineEmits, defineProps, ref, watch } from 'vue';
import { AppButton, AppTypography } from '../base';
import DialogBase from './DialogBase.vue';

const props = defineProps({
  modelValue: { type: Boolean, required: true }, // for v-model
  width: { type: [Number, String], default: 400 },
  title: { type: String, default: '' },
  message: { type: String, default: '' },
});

const showDialog = ref(props.modelValue);
watch(
  () => props.modelValue,
  (val) => (showDialog.value = val)
);

const emits = defineEmits<{
  (e: 'close'): void;
}>();

const handleClose = () => {
  emits('close');
};
</script>

<template>
  <DialogBase v-model="showDialog" :width="width" @close="handleClose">
    <template #body>
      <div class="py-8 px-6">
        <AppTypography element="h1" type="large" class="font-title-large text-center mb-4">
          {{ title }}
        </AppTypography>
        <AppTypography element="p" class="font-body-regular text-center">
          {{ message }}
        </AppTypography>
      </div>
    </template>
    <template #actions>
      <div class="pb-8 px-6">
        <AppButton block @click="handleClose"> Close </AppButton>
      </div>
    </template>
  </DialogBase>
</template>

<style lang="scss" scoped></style>
